import SelectionData from "../Graphs/SelectionData";

export function getRegions() : SelectionData[] {
    return [
        /*{Type : "Vsetky", Code : "all" },*/
        { Type: "Praha", Code: "0" },
        { Type: "Středočeský kraj", Code: "1" },
        { Type: "Jihočeský kraj", Code: "2" },
        { Type: "Plzeňský kraj", Code: "3" },
        { Type: "Ústecký kraj", Code: "4" },
        { Type: "Královéhradecký kraj", Code: "5" },
        { Type: "Jihomoravský kraj", Code: "6" },
        { Type: "Moravskoslezský kraj", Code: "7" },
        { Type: "Olomoucký kraj", Code: "8" },
        { Type: "Zlínský kraj", Code: "9" },
        { Type: "Kraj Vysočina", Code: "10" },
        { Type: "Pardubický kraj", Code: "11" },
        { Type: "Liberecký kraj", Code: "12" },
        { Type: "Karlovarský kraj", Code: "13" },
    ];
}

export function getYears() : SelectionData[] {
    return [
        /*{Type : "Vsetky", Code : "all" },*/
        { Type: "2025", Code: "2025" },
        { Type: "2024", Code: "2024" },
        { Type: "2023", Code: "2023" },
        { Type: "2022", Code: "2022" },
        { Type: "2021", Code: "2021" },
        { Type: "2020", Code: "2020" },
        { Type: "2019", Code: "2019" },
        { Type: "2018", Code: "2018" },
        { Type: "2017", Code: "2017" },
        { Type: "2016", Code: "2016" }
    ];
}